const Style = {

  header: 'pb-4 mb-4',
  label: 'text-sg-mut text-sm',

}

export default Style;